import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import Headline5 from '../Typography/Heading/Headline5';
import { ListItem } from '../List';

export const StyledListItem = styled(ListItem)`
  && {
    padding: 16px 16px 16px 0;

    a {
      display: flex;
      align-items: center;
    }
  }
`;

const ImageContainer = styled.div`
  display: inline-block;
  width: 100px;
  padding: 0 16px 0 0;
`;

const marketListItemPropertyTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.node,
};

type MarketListItemProperties = InferProps<
  typeof marketListItemPropertyTypes
>;

const MarketListItem = ({
  title,
  image,
}: MarketListItemProperties) => (
  <StyledListItem tag="div">
    <ImageContainer>
      {image}
    </ImageContainer>
    <Headline5 tag="h2">
      {title}
    </Headline5>
  </StyledListItem>
);

MarketListItem.propTypes = marketListItemPropertyTypes;

export default MarketListItem;
